import $ from 'jquery';

export default class UserInfoUtils {

    static onCRUserInfoReady(handler) {
        if (window.CRUserInfo && window.CRUserInfo.ready && typeof window.CRUserInfo.ready === "function") {
            window.CRUserInfo.ready().then(handler);
        } else {
            $(document).on('userInfo_ready', handler);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/UserInfoUtils/index.js